export default "__VITE_ASSET__BmIIMHf___"